module.exports = __webpack_public_path__ + "static/Icons_USDA_inactive-cb5698b44fdc0dbfeb8e8fc48c3c26ad.png";